/**
 * PageEntityContext — « fiche de la page courante » (WKF-013 §5.4).
 *
 * Chaque page de détail (client, apprenant, formation, lieu, restauration,
 * hébergement, frais, article…) déclare la fiche qu'elle affiche via
 * `usePageLinkedEntity(type, id, label)`. Le **centre de notifications** (bouton
 * « Nouvelle tâche » de la cloche, présent sur TOUTES les pages) lit ce contexte
 * pour **pré-remplir automatiquement** le lien — sans bouton dédié par fiche. Le
 * lien reste modifiable / retirable dans la modale.
 */

import { useMemo, useState } from 'react'

import type { LinkedEntityValue } from '@/lib/linkedEntity'

import { PageEntityContext } from './PageEntityContext.helpers'

export function PageEntityProvider({ children }: { children: React.ReactNode }) {
    const [pageEntity, setPageEntity] = useState<LinkedEntityValue | null>(null)
    const value = useMemo(() => ({ pageEntity, setPageEntity }), [pageEntity])
    return <PageEntityContext.Provider value={value}>{children}</PageEntityContext.Provider>
}
